'use client'

import clsx from 'clsx'
import { Fragment } from 'react'

import { HistoryItem } from '@wartek-id/breadcrumb'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { LinkWithTracker } from '@/components/LinkWithTracker'

export const Breadcrumbs = ({
  items = [],
  className = '',
  itemClassName = '',
}: {
  items?: HistoryItem[]
  className?: string
  itemClassName?: string
}) => {
  return (
    <div
      className={clsx(
        'breadcrumb flex flex-wrap items-center gap-2',
        className
      )}
    >
      {items.map((item, index) => (
        <Fragment key={item.id}>
          {index !== items.length - 1 ? (
            <>
              <LinkWithTracker
                href={item.href}
                data-testid={`breadcrumb--${item.id}`}
                className={clsx(
                  'max-w-[150px] truncate text-sm text-[color:var(--color-text-subdued)] hover:text-[color:var(--color-text-default)] hover:underline',
                  itemClassName
                )}
              >
                {item.text}
              </LinkWithTracker>
              <Icon color="disabled">chevron_right</Icon>
            </>
          ) : (
            <>
              <Text
                variant="body-sm"
                data-testid={`breadcrumb--${item.id}`}
                className={clsx(
                  'max-w-[150px] truncate text-sm',
                  itemClassName
                )}
              >
                {item.text}
              </Text>
            </>
          )}
        </Fragment>
      ))}
    </div>
  )
}
